<template>
    <div class="main-modem-desk">
        
        <el-dialog v-model="isWindowFrameware" v-if="isWindowFrameware" title="Прошивка" width="800">
            <VersionWindow />
        </el-dialog>
        <div class="one-part-modem left-part-modem">
            <div class="control-line-modem">
                <input type="text" placeholder="Поиск..." disabled>
                <button @click="isWindowFrameware = true">Прошивка</button>
            </div>
            <div class="modem-list">
                <div 
                    v-for="modem in modemList" :key="modem.id"
                    class="modem-line"
                    :class="{
                        choosed: modem.id == choosedModem.id
                    }"
                    @click="clickOnModem(modem)"
                >
                    
                    <div class="modem-quick-info">
                        <p>{{modem.mac_address}} ({{ modem.company_name }})</p>
                    </div>
                    <button v-if="modem.id == choosedModem.id" @click.stop="choosedModem = {}">
                        <img src="@/assets/imgs/company/cross-company.svg" alt="cross">
                    </button>
                </div>
            </div>
        </div>
        <div class="one-part-modem right-part-modem">
            <div class="comtent-modem-param" v-if="choosedModem.id">
                <div class="hedear-modem-param">
                    <p class="middle-high">{{ choosedModem.mac_address }}</p>
                    <button @click.stop="choosedModem = {}">
                        <img src="@/assets/imgs/company/cross-company.svg" alt="cross">
                    </button>
                </div>
                <div class="params-modem">
                    <p class="param-line-modem">Версия: <strong>{{ choosedModem.version?choosedModem.version:'-' }}</strong></p>
                    <p class="param-line-modem">Последнее подключение: <strong>{{ choosedModem.last_connection_time?choosedModem.last_connection_time:'-' }}</strong></p>
                    <p class="param-line-modem">CCID: <strong>{{ choosedModem.sim_ccid_number?choosedModem.sim_ccid_number:'-' }}</strong></p>
                    <p class="param-line-modem">IMEI: <strong>{{ choosedModem.sim_imei_number?choosedModem.sim_imei_number:'-' }}</strong></p>
                    <p class="param-line-modem">IMSI: <strong>{{ choosedModem.sim_imsi_number?choosedModem.sim_imsi_number:'-' }}</strong></p>
                    <p class="param-line-modem">Оператор: <strong>{{ choosedModem.sim_operator?choosedModem.sim_operator:'-' }}</strong></p>
                    <p class="param-line-modem">Уровень сигнала: <strong>{{ choosedModem.sim_signal_quality?choosedModem.sim_signal_quality:'-' }}</strong></p>
                    <p class="param-line-modem">Номер телефона: <input type="text" v-model="modemPhoneNumber"><button @click="savePhoneNumber(choosedModem.id, modemPhoneNumber)">Сохранить</button> </p>
                    <div class="param-line-modem">
                        <p>Обновление:</p>
                        <el-select style="width: 40%;" v-model="choosedFrameware" placeholder="Select" size="small" :loading="loadingFrameWareModem" @visible-change="openSelectListModem">
                            <el-option v-for="item in frameWareList" :key="item.id" :label="item.version" :value="item.id" />
                            <el-option label="Select" :value="0" :key="0" />
                        </el-select>
                        <button @click="submitUpdate('modem', choosedModem.mac_address, choosedModem.id, choosedFrameware)">Прошить</button>
                    </div>
                </div>
                <div class="connected-device-place-modem">
                    <p>Подключённые устройства:</p>
                    <div class="connected-device-modem">
                        <div class="device-modem" v-for="device, index in devicesByModem" :key="device.id">
                            <p>Name:  <strong>{{ device.name?device.name:'-' }}</strong></p>
                            <p>MAC:  <strong>{{ device.mac_address?device.mac_address:'-' }}</strong></p>
                            <div class="param-line-modem">
                            <p>Обновление:</p>
                                <el-select style="width: 40%;" v-model="choosedFramewareSensor[index]" placeholder="Select" size="small" :loading="loadingFrameWareSensor" @visible-change="openSelectListSensor">
                                    <el-option v-for="item in frameWareList" :key="item.id" :label="item.version" :value="item.id" />
                                    <el-option label="Select" :value="0" :key="0" />
                                </el-select>
                                <button @click="submitUpdate('sensor', device.mac_address, device.id, choosedFramewareSensor[index])">Прошить</button>
                            </div>
                            <p class="small-text"> <strong>{{ device.type }}</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VersionWindow from '@/pages/modem/VersionWindow.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'ModemPage',
    computed: {
        // ...mapGetters({
        //     // modemList: 'getModemList',
        //     // devicesByModem: 'getDeviceListByModem',
        //     frameWareList: 'getFrameWareList'
        // }),
        ...mapGetters('modem', {
            modemList: 'getModemList',
            devicesByModem: 'getDeviceListByModem',
            frameWareList: 'getFrameWareList'
        }),
    },
    components: {
        VersionWindow
    },
    data() {
        return {
            choosedModem: {},
            modemPhoneNumber: '',
            isWindowFrameware: false,
            choosedFrameware: 0,
            choosedFramewareSensor: [],
            loadingFrameWareModem: false,
            loadingFrameWareSensor: false,

        }
    },
    watch: {
        choosedModem(newVal) {
            if (newVal.id) {
                this.modemPhoneNumber = newVal.sim_phone_number
                this.getDevicesByModem(newVal.id)

            }
            this.choosedFrameware = {}
        }
    },
    methods: {
        ...mapActions('modem', {
            getModemList: 'getModemList',
            getDevicesByModem: 'getDevicesByModem',
            putPhoneNumberOfModem: 'putPhoneNumberOfModem',
            getFrameWareList: 'getApiFrameWareList',
            postUpdatingQueue: 'postUpdatingQueue',
        }),
        clickOnModem(modemData) {
            this.choosedModem = modemData
        },
        async savePhoneNumber(id, phoneNumber) {
            await this.putPhoneNumberOfModem({
                id: id,
                phone_number: phoneNumber
            })
            this.modemPhoneNumber = this.choosedModem.sim_phone_number

        },
        submitUpdate(type, mac, id, updating) {
            let data = {
                id: id,
                type: type,
                mac: mac,
                frameware: updating
            }
            this.postUpdatingQueue(data)
        },
        openSelectListModem(visible) {
            if (visible) {
                this.loadingFrameWareModem = true
                this.getFrameWareList('modem')
                this.loadingFrameWareModem = false
            }
        },
        openSelectListSensor(visible) {
            if (visible) {
                this.loadingFrameWareSensor = true
                this.getFrameWareList('sensor')
                this.loadingFrameWareSensor = false
            }
        }
    },
    created() {
        this.getModemList()
    }
}

</script>

<style scoped lang="scss">
 .main-modem-desk {
    width: 100%;
    max-height: 93vh;
    // background: red;
    display: flex;
    overflow: auto;

    .one-part-modem {
        margin: 1vh 1vw 1vh 1vw;
        max-height: 91vh;
        overflow: auto;
        width: 48vw;
    }

    .left-part-modem {
        // background: blue;
        .control-line-modem {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            input {
                border-bottom: 1px solid var(--gray-dark-color);
            }

            button {
                border: 1px solid var(--gray-dark-color);
                background: none;
                border-radius: 3px;
                padding: 5px 15px;
                width: 121px;
                height: 27px;
                font-family: var(--font-family);
                font-weight: 400;
                font-size: 14px;
                color: var(--black-color);
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                   background: #94949417;
                }

                &:active {
                    background: #9494943a;
                }
            }
        }
        .modem-list {
            .modem-line {
                border: 1px solid var(--gray-dark-color);
                border-radius: 4px;
                padding: 5px 14px;
                transition: all .2s ease;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;

                button {
                    display: flex;
                    background: none;
                    cursor: pointer;

                    img {
                        width: 15px;
                    }
                }

                &:hover {
                    background: #94949417;
                }

                &:active {
                    background: #9494943a;
                }
                &.choosed {
                    background: var(--gray-dark-color);
                }
            }
        }
    }

    .right-part-modem {
        // background: green;

        .comtent-modem-param {
            margin: 28px 10px  10px;
            border: 1px solid var(--gray-dark-color);
            border-radius: 4px;
            padding: 10px 20px;

            .params-modem {
                padding: 10px 30px;

                .param-line-modem {
                    display: flex;
                    flex-direction: row;
                    margin: 5px 0;

                    input {
                        border: 1px solid var(--gray-dark-color);
                    }

                    button {
                        margin: 0 5px;
                        background: var(--background-blue);
                        color: var(--background-white);
                        padding: 2px 4px;
                        border-radius: 4px;
                        transition: all 0.2s ease;

                        &:hover {
                            background: rgba(63, 81, 181, 0.809);
                        }

                        &:active {
                            background: rgba(63, 81, 181, 0.622);
                        }
                    }
                }
            }

            .connected-device-place-modem {
                p {
                    margin-bottom: 5px;
                }

                .connected-device-modem {
                    .device-modem {
                        width: 100%;
                        border: 1px solid var(--gray-dark-color);
                        border-radius: 4px;
                        margin-top: 10px;
                        padding: 0 10px;

                        button {
                            margin: 0 5px;
                            background: var(--background-blue);
                            color: var(--background-white);
                            padding: 2px 4px;
                            border-radius: 4px;
                            transition: all 0.2s ease;

                        &:hover {
                            background: rgba(63, 81, 181, 0.809);
                        }

                        &:active {
                            background: rgba(63, 81, 181, 0.622);
                        }
                    }
                    }
                }
            }

            .hedear-modem-param {
                display: flex;
                justify-content: space-between;

                button {
                    display: flex;
                    background: none;
                    cursor: pointer;

                    img {
                        width: 12px;
                    }
                }
            }
        }
    }
 }
</style>